export enum FeatureFlags {
  PendingApprovalsV2 = '2F6B8E1D-4A9C-4E7B-9F3A-6C1D8E2B5A47',
  OfficeLogoUpload = 'C4202A9E-076D-46E0-8996-9D58FE35B981',
  ShortPayAdmin = 'B1D4F3A2-6C7E-4F0B-9A2D-3E5C7A9B1D40',
  ReleasePendingApprovalsSummaryCount = 'ECD23357-A66D-4599-B19A-7505C345189B',
  ReleaseBulkOrderUploadUI = 'D8B76BA4-6F52-4A35-BD8F-3A7F8B7C910E',
  ReleaseProductFeedback = '88AB12BF-6941-4364-8728-537E779CCC60',
  HelpdeskSelfService = 'A6FBC529-BEF7-4A22-A9F1-B5E413C1D5A7',
  JiraMetricsService = 'FF65A027-D224-48CE-AB09-54A63B384F76',
  TimeOffCalendarService = '3E7C1A2F-9B4D-4E6A-8C3F-2A5D9E1B7F40',
  BedrockAssistant = '7C2B8F5E-9E64-4C2E-9C61-2F0C0D8A6B3E',
  ltlStopModalCleanup = 'CDA59A8E-AEC3-4870-AF2E-00E3C53E9EBE',
  release_document_highpriority_queue = '4025E2E2-CC20-46FF-BD66-9C8E9CE03C5B',
  LoadboardEmptyLoadsCustomerSetting = 'EEDA3C21-85CD-49DC-89CD-014AC91782EE',
  AbleToForceDeletePosting = '87885CFF-29FB-44F8-AC9C-01539A638DAB',
  OfferManagerUI = '55E441AD-E417-4A79-8C82-016E10D0FAA9',
  // BAR-652 — mirrors BE FeatureFlagClassGuids.OfferManagerGroups
  OfferManagerGroups = '9E2F4A71-6C38-4D5B-8A1E-A41C7B9D0E62',
  // BAR-652 — perm.offermanager-manage-visibility-groups
  OfferManagerManageVisibilityGroups = 'A6D4C8E1-3B72-4F05-9E18-7C2B5A0D6F43',
  AllowInsuranceDeletion = '6352DB64-9DBE-4EC1-A76A-038627C9C4C0',
  EDIChangeTender990 = '96C310AF-3413-4C75-8653-05E89036D6C6',
  SuggestedClass = '90058082-2C79-485A-A614-07F12F00E549',
  CatalogLineItemFillEmptyOnly = '565CA603-9056-4F9D-ACB8-0982FE23F747',
  FilterVendorVerifiedContactsForLoad = 'AE30F274-7112-4F84-A4CB-0A106D5F6D9A',
  TrackingFrequency = '1A58EC13-C622-4C9E-AB76-0A1EFB7D1C39',
  AllowEmptyInLoadboardViews = '9ECC2759-C733-4BF3-8DD5-0CEFD8C764F5',
  V4CustomerOpenBalancePDF = '852B8A7B-F611-4CA5-8AA2-10DB8E5A2DFD',
  EDIReopenLoadChangeTender = '940556FE-673F-4B91-A44D-11E00145BC2D',
  TenderAuto990AcceptDecline = '23FD96CB-5CBF-4B70-B3AC-146BCAADF159',
  AccountManagerAsOrderRep = '2AEC6206-E142-409D-985B-18494853D3B0',
  Falvey = '83054D39-B3BB-43D9-9AFD-1D22FD2E2FA0',
  TruckerToolsEnabledByOffice = 'C30F2474-7B1E-435E-84C0-1EAE284B1FED',
  AddressBookFacilityDetails = '6E9F2B3A-8C1D-4F6E-9A55-7B2E4C9D1A03',
  ltl_VNEXT_2856_TableRefactor_ReadFromNew = 'B3146A6D-FDF2-4A4D-B5A9-20C1EB11E7D6',
  V4RateConfirmationCarrierPDF = 'E807E595-0A9F-4AC6-AC40-27D2B80F14CE',
  LtlCarrierBlockInclude = 'A3F7C4D2-9E61-4B8A-8F3D-2C7E5A91D4BF',
  V4OrderSummaryPDF = 'A38360A2-5FC3-46A0-9BA9-3352B702D3EE',
  EDIValidationTesting990 = '80A146CC-91F0-49B5-8FF3-36BE59AAF417',
  StopMileage = '339B3ECD-2994-4EEF-A4CB-38DA7C86A468',
  TruckerTools = '719A66FA-AB7B-4EE2-902B-39973C0CD48C',
  EDIChangeTenderEmailNotification = 'FB2ED01B-B7D0-4EE8-91AD-39E6598F7CD7',
  TruckerToolsEldAssetApi = 'AD3A8D5C-DA70-43F9-9A77-469B3D796E48',
  feature_order_block_save_on_neg_credit_limit = '50856C16-324B-4700-AB5E-4C80C149EC2F',
  EDI210Rules = '33BA4E58-85C1-45DB-9570-4E1D9063FE34',
  CarrierVerificationLockdown = '22FFDDBE-1554-43E6-97ED-5224E32E46F2',
  FeatureCarrierProfileNonUsMcDotExemption = '5D43C2A9-7A2C-4F9E-9C61-8C3B5D2E4F17',
  EDIDropoffDriverInAuto214 = 'DC4B1D2E-8F14-47AB-B4F5-5517FAA2E143',
  V4RevenueSearchGrouping = '165530D9-737C-41C4-AADD-55F78E0CCD8E',
  CopyDetails = '8A7E8AB8-5355-4F33-98CD-584159792B10',
  CustomerFlagForFinancialExposure = 'BB80E290-084C-4D0C-854D-5CA45ABF4DAA',
  UseHighwaySecureRateCon = 'E63BB183-31D9-4883-9660-5D9A4A30493F',
  EDIHandleTenderRules = '90C58715-08BE-4F74-88BB-5E58026F8352',
  RestrictRefrigeratedLoadsByHWYAssessment = '25515121-5B6A-421E-ACA7-5F7C3821F648',
  LtlSavedQuotesServerSideQuerying = '21C00080-84F8-4CDF-8DE6-60EF911240F1',
  V4EFSEnabled = '15C60C44-C22E-4F05-A5DA-62F226892AC5',
  ShowCustomerInstructions = 'AB66232C-1379-4EC6-AD91-65D4BD46AA7C',
  RequiredBeginTimeRange = '97455B2B-E889-4A3C-AB1C-66D664E24715',
  EDIValidationTesting214 = 'EA3317AB-78C3-4C50-876C-694E967A25CC',
  V4CustomerPastDuePDF = '9DFE2A5B-6BE6-4C6D-BC8B-6A7F7248CB03',
  CustomerCommentVisibility = 'CAC8A0BB-57F7-4AC4-ABCC-6FD4A31F5632',
  OfficeFilters = '42B1682C-699C-4A5C-B9AD-6FFE7F69C681',
  AbleToManageVendorBilling = 'AF1D07DE-5591-44CA-8BBE-758739B5636B',
  OfferDetails = '00D2CCD4-27BE-4DF8-8D89-79CE616487DF',
  HighwayUpdateInsurance = 'FCFEC86F-6824-45ED-B1E3-7B69C46BC481',
  EDI214Rules = '2FE42E1E-55FF-41FC-86B7-7CA22AA84ED6',
  LoadboardEmptyLoads = 'D40B6EB0-A137-47AF-A364-7E2B738AD878',
  AssignMultiofficeGroupsForCustomer = '593DE317-ABAF-4002-BA8C-7F517608F00E',
  rls_ui_show_stop_window_non_ltl = 'A918AAF8-F698-40F5-9650-80D6D7F211B0',
  PrepopulateOrderIdOnMultiPostingCommentEnabled = '3E07CD52-9D40-4E71-9844-82BFCD8F5E89',
  feature_tms_Prepopulate_LoadNumber_Single_Posting_Comment = 'BB880F98-58B9-451F-8911-03C42328CC83',
  V4BOLPDF = '77351FEF-16CA-4BB0-A191-834EE6B19D0E',
  EDIValidationTesting204 = 'C5BDDF6C-EE32-467E-A658-84505C603760',
  EDI990Rules = '2AD9BE1A-45A2-4A63-AD99-8A42D85C3483',
  AllowExportContact = '94752145-DB69-4BF2-8A86-91D19D12BCA8',
  LtlChunkQuoting = 'F2BB8363-1B16-4A5A-A10D-9735B2E82859',
  PolicySharedCapacity = '1C9B556D-E981-48EA-A03F-9D603B306525',
  ViewNegativeCredit = 'BE81D8AA-4684-4F5A-919F-9D8F7991734F',
  EDIPickupDriverOutAuto214 = '71F3CB09-CB64-485D-AE56-9E7E2803F0C0',
  EDI214Notifications = '66A1CC01-38E1-4F25-A4D5-9F525E5DED63',
  UseShortQuoteGroupLocator = 'A9AEC57E-55F2-424E-A23F-A19A8DF9DFF0',
  CanForceUnlock = 'FDC2F3D1-DB6A-4BF4-AE42-A38954E832CD',
  CarrierBlacklistReport = 'D4A1E6B7-3F52-4C9A-8E16-7B2C5A9F0D31',
  V4RateConfirmationCustomerPDF = 'FE044A00-4411-487F-9E77-A54EFAA5AD04',
  autopopulatepostingfromload = '61492E8D-378C-40E5-8A19-A63698BA40EE',
  MilitaryTime = '0C6CDB03-0A0D-412D-AFE4-A7559990A46F',
  TurnOffLoadboardSidePanel = 'B57DDB8B-2086-4258-A422-ABBF226C8B65',
  AllowEmptyInLoadboardViewsUI = 'C18435BC-AF97-4E20-8B7D-AD81EFBEB34C',
  CapacityOpsRepUser = 'D14FC805-084A-46A9-BC33-B4C191523767',
  EDIOnLoadRules = 'E13431A9-EA65-41F5-849E-B5638ECBE353',
  EDIPickupDriverInAuto214 = 'A0F1CB87-08BE-4B33-B183-B7C66DB2B76E',
  CustomerFlagForReview = 'AA1C41C1-11CF-4593-BD59-BB077F8D4861',
  V4InvoicePDF = 'E5D1E951-81EE-4D2F-AB62-BDC70726900A',
  EDIAutoVoid = 'DC281CB8-79F4-4BAB-A47E-BEF9B5E63223',
  EDIDropoffAppointmentAuto214 = '4AA92671-504B-44D3-8B08-BF99257C5356',
  CarrierActivationManagement = '3E8DA8D3-9367-4AF6-8E08-C4190FCDC789',
  AllowCapacityGroupCustomerAssignment = '60912FB6-9705-45EC-9289-79B549D0DF40',
  CarrierLtlSetup = '2A7F2849-F5A9-413F-BBD3-C57539E086EB',
  // LTL Accessorial schema refactor — global flag, mirrors BE FeatureClassGuids
  LtlAccessorialsSchemaRefactorRead = 'C1A84F2D-73B9-4E56-9A2F-6D0C8B17E345',
  EDIPickupAppointmentAuto214 = 'BC8374E3-AD77-47D2-8556-C9469D2E9463',
  perm_loadboard_restrict_status_edit = 'F52942DD-A406-45C4-AFA5-CEC448D68A82',
  EDIRejectChangeTender = 'F4E3B44B-06B5-4327-AE91-CF67C4B2A729',
  CarrierContactOwnershipSource = '06FF30D1-4CA8-4E01-9408-D0315DE291EA',
  PreventDispatchingForModifiedLoads = 'FBA5EE2C-2CC1-4D7E-A268-D85CA8118E75',
  V4CarrierOpenBalancePDF = 'FF141D90-8441-4608-BD55-DCA79A090857',
  LoadSure = '6F088777-85A0-4A26-8465-DE957F6A2391',
  EDIDropoffDriverOutAuto214 = 'E55402EA-C407-4DB7-95BD-DFB3E03FDDEC',
  EDIValidationTesting210 = '6BE9734A-8DB4-41E8-B55B-E06C2C598C0E',
  PointOfSaleNotes = 'D251B46B-FE09-4EF0-95C3-E5DE4E64E202',
  UseHighwayAgentSecureRateConLiabilityDisclaimer = '7F4E8181-4AEA-493F-91C3-E81C31EDAE92',
  V4LTLQuoteParametersPDF = '62DD389E-5108-44DE-A903-E8DA204676F9',
  MyOffers = 'ED047E46-7087-4FC5-AF95-EB8F4082F97D',
  RateConViewPdfButton = 'F4A3225D-A2E7-4255-9850-F1D5D619AD60',
  OperationsRep = '1D4F96FE-E32E-4BC5-8C18-F305AFEA1676',
  FuelReimbursement = '51A828DE-915D-4791-9476-F3BF9156D065',
  CanEditCapacityOwner = '694EFF24-3323-4A29-8C37-F49C2D50641B',
  FeatureCapacityRichBidAlert = 'F8C3D35E-D2F0-4DE7-9B11-DF3A0D7BC160',
  LanePreference = '57323F4B-784D-462F-B06E-F816CE5D0CE3',
  HideElectronicTrackingUpdatesByDefault = 'BA4DA540-6C26-4B0C-8388-F865845D7C81',
  TMSApiClientDispatch = '2D02E82B-25B5-4F48-97B2-F8B7F41ECAF1',
  LockConcurrentEditForOrder = '153608EC-F09D-4911-A1E4-FF52F06CC69E',
  MaxBuyBEOfficeLevel = '6F2ECBC1-D04E-4D1E-8237-FF5420544B24',
  V4CapacityFinder = '979FE97B-0594-4ED9-A500-345AC1C30A86',
  V4BolRateConInvoice = '57A2B74A-D983-4371-86D5-A87F54B4E01D',
  VendorManagement = '1D7B7F4B-3F28-4C71-8E28-34C033428469',
  FtlNumberOfPieces = '7A2A28EC-9C7D-40EE-967A-54AE55A7F14D',
  V4Invoicing = 'FB49599C-D150-4044-AFC3-A671BA7623EF',
  ShowBlockingCustomerStatuses = '7DBAC0CC-ED99-4240-947F-8729DD396C89',
  BlockActionsForBlockingCustomerStatuses = 'F7B0E84B-78A6-4704-9437-C20DF5590B51',
  V4CapacityFinderAllowPastDates = 'F20C109C-92B6-4533-B602-256FECA6840C',
  V4ShippingLabelPdf = 'B33491E7-9A73-412A-BF77-6B248F0AF68E',
  ReleaseMobileOrderCreationWizard = '9fe999d3-a059-4f31-a7b8-4807ad7f8452',
  UserAdjustmentDates = '8A865918-5A57-457A-B954-B9BA831A2474',
  feature_tms_orderflag_state_machine = 'E15BCD0E-581D-4630-8320-D4D3AE66A5E8',
  LtlDisplayFailedQuotes = 'e3fd7ea5-e186-4ef3-a9a9-486d6ef339d8',
  LtlQuoteResultsRequestSummary = '5ebbd72a-0723-428a-917a-4fbaa8ddff8a',
  permission_auto_update_load_status = 'ECA7A34E-158E-40AF-92C7-CAB9AEE68BDE',
  permission_toggle_load_state_machine_exclusion = '90672068-50D3-47C0-B0B4-32CF1A4EE2E6',
  posting_equipmentcode_override = '5790ef55-0989-44d0-918e-90237daeb244',
  PortBillingApi = 'C53EFCDB-F90E-46F6-9EED-0A16D04F4817',
  PortRemainingV3Apis = 'BBC15CEE-3326-4399-9234-84958C528068',
  CreditAppApi = '2dda3394-3a49-478f-bc21-806612279179',
  'release.credit-application-geocoding' = 'A8DE82A1-32CA-426A-9F78-EEB65579360D',
  LtlGapLogic = 'b3e7a1c9-5d24-4f86-9a1b-0c7e2d4f6a83',
  ReleaseCreditAppPdfV2 = '40663141-5E12-4E90-BA08-7E97055119FE',
  perm_carrier_profile_set_as_dupe_enabled = 'C45F6477-D135-4A5E-B353-DD276356D3C9',
  perm_edit_posting_groups_enabled = '455d9ce0-3745-4005-bb4d-e927007ca563',
  perm_disable_hwy_carrier_validations = '7e740de1-b97d-4b1d-b91c-b1d6252e2fa8',
  FeatureUserEditCustomerTmsPortals = 'C003126D-D434-4F80-B1EF-57FF803FD2CD',
  FeatureCustomerTmsPortals = 'D78E599B-F25C-4C70-AAC0-1CFB5F503963',
  enable_24_hour_in_and_out_times = '584e9bad-620e-4423-9969-46287880c390',
  EnableLtlQuoteSorting = '8E6CD0D8-127D-4C1D-AAC4-F9DEDAF9A7D4',
  PermissionCustomerManageArchived = 'A8801A01-C080-4A71-ADF0-A2A06EC7809E',
  PermissionCustomerCollectionFlag = 'C6827066-F266-4FE9-AD12-C330610D1E27',
  feature_show_drop_trailer_accessorial = 'dc78b3c2-ffee-497a-8e98-34a30e11f35c',
  EnableGenlogsCapacityFinder = '136aaead-53f3-4df6-99f3-99b3fc02d29e',
  SideBarCustomerQueue = '0a8c6146-06a8-4638-b38c-438dfb3cecd3',
  SidePanelMuteNotifications = '4B6B1FBA-C2E8-4D66-9F11-C0E37F55A941',
  ShareCapacityLoadboardSidePanel = '7f3a9c21-6d84-4b52-ae17-92c5f8d04361',
  MassShareCapacity = '4E719825-3BB0-46C5-BC1C-A43CE9AD47C8',
  LtlLiabilityEducation = 'C6962A08-759D-48B0-BBD2-F4D089533ACD',
  LtlCarrierQuoteExpirationDisplay = '6D4A2F91-8B3E-4C7D-9A15-2F60E8D3B7C4',
  ReleaseNewFeatureFlagPortal = 'd1dfdf7c-6c74-4926-a143-9352327b7ba8',
  EnableLoadboardSidePanelEscapeToClose = '4b2f404b-465f-4788-ada8-2836834befbd',
  LtlQuoteManualAddressOverride = '2E966759-80F3-4AA7-828F-85A85EE2277D',
  AutoPopulateOwnedCapacityRep = 'C84e2f91-7a36-4d08-bb52-16f9a3c72584',
  EnableAddLoadMobile = '21789515-0ccf-4d7f-81d8-7ad1f0ccdf4d',
  LtlPublicApiWarnings = 'A3F1B6E2-7C94-4D18-9E5A-2B0F7D4C88A1',
  UiRichTextEditor = 'b3df4786-4922-47a7-b139-4651fccef900',
  EnableOfferManagerAutoPopulateCarrierCharge = 'B9D1A3C0-4F2E-4A5B-BD3F-1C2E3F4A5B6C',
  CarrierPayAllowMaxPayUpdate = '5B8E653C-3AFF-4F35-9E78-62B58BA39498',
  laneSearchGridSpecificationFiltering = 'f34a62c9-ec04-46eb-9f34-af6f44cb38d1',
  CapFinderLiveOffersRemoveCreateDateRestriction = '6b208a29-8cdf-48b3-ae75-dd77a4e96f09',
  RequireCarrierAssignmentToProgressStatus = '7f3c9a21-6d84-4b17-92e5-a53d8c7f1046',
  PermissionRevenueDashboardAllowTeamUserVisibility = '2A31A0A1-5B9C-4D4D-8F9F-1D3B0C8E7A11',
  CopyOrderClearCarrierRatesForTL = '3e7a9b42-61d5-4c8f-b2a6-9d30f7e154c8',
  CarrierPayPreventPayLineItemsOverMaxRate = '8f4c2a71-6d93-4b58-ae17-c5f0d82b9436',
  EnableLoadLaneHistory = '3c7e9a42-1b65-4f08-9d31-6a82e5c4b7f0',
  PermissionCarrierRemoveBlacklistedCarrier = 'B4F38A6A-8164-4ECD-A38C-5ED861659369',
  FeatureVoidVendors = '1805e58f-e8a4-4c75-973b-595d34dae8d8',
  FeatureTMSClaimHold = 'CD16846A-A8AC-43C2-B504-FAF8C9AEE286',
  LtlSupportMixedCommodityPalletOnLoad = '396e1260-9afc-49e4-be03-d32340c210dd',
  ReleaseMobileCopyOrderFlow = '7b2e4f91-c836-4a15-b7d0-52e9f6c3148a',
  OptimizedRevenueSearch = '2773274C-6AEF-4ACA-97C2-0D107034B11E',
  EnableLoadDetailsCarrierBounceTracking = 'ff31cacd-6cf4-493b-ad4a-e0b6b3333d18',
  CarrierRestrictionsTab = '7f3a9c2e-6d41-4b85-a0f7-9e2c6d1b8435',
  ShowEquipmentInRevenueSearch = 'C7E13034-AC83-47D4-BE62-57CA877EF33B',
  LtlUnifiedQuoteComponent = 'F01435B3-7F18-4816-8FB1-CF3B7052F3FF',
  BOLEmptyEmailToDefault = 'E5E3C16D-CCFC-4DF6-B1A8-5FD764173249',
  NotificationPreferencesCard = 'bc76c739-d318-45d9-b5aa-c45c5519808b',
  SaveButtonConfirmation = 'd69320ca-da35-42c7-a37b-b254a3247c7f',
  ReleasePostingModeOptions = '6C675587-5F21-41AA-A20E-9DE04AC2F38B',
  feature_ltl_search_pickup_number = 'C7A3E9D1-4B82-4F17-9E6A-2D8F5B0C3A41',
  PermissionAllowLoadRepMaxPayUpdate = 'EEA6EA53-214D-4D90-AB1F-D43A7EBC83B1',
}

/**
 * Feature *names* for flags resolved per-user through
 * `getEffectiveIsEnabledForUserByFeatureName`, which takes the name rather
 * than the GUID held in `FeatureFlags`.
 */
export const USER_FEATURE_NAMES = {
  customerFlagForReview: 'CustomerFlagForReview',
  customerFlagForFinancialExposure:
    'permission.customer-flag-for-financial-exposure',
  prospectFuzzyApi: 'release.use-prospect-fuzzy-match',
  featureFlagExperiments: 'release.feature-flag-expirements',
} as const;
